import { defineStore } from "pinia";

interface AlertState {
  text: string;
  visible: boolean;
}

export const useAlertStore = defineStore("alert", {
  state: (): AlertState => ({
    text: "",
    visible: false,
  }),
  getters: {
    isVisible: (state): boolean => state.visible,
    getText: (state): string => state.text,
  },
  actions: {
    setAlert(text: string, isGenericMessage = false) {
      if (isGenericMessage && this.visible) {
        return;
      }

      this.text = text;
      this.visible = true;
    },
    dispose() {
      this.text = "";
      this.visible = false;
    },
  },
});
